import { render, staticRenderFns } from "./FilesTab.vue?vue&type=template&id=2193675b&scoped=true&"
import script from "./FilesTab.vue?vue&type=script&lang=js&"
export * from "./FilesTab.vue?vue&type=script&lang=js&"
import style0 from "./FilesTab.vue?vue&type=style&index=0&id=2193675b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2193675b",
  null
  
)

export default component.exports